import { defineMessages } from 'react-intl';

export default defineMessages({
  resetApplication: {
    id: 'ResidentPortal.resetApplication',
    defaultMessage: 'Reset Information',
  },
  resetApplicationTooltip: {
    id: 'ResidentPortal.resetApplicationTooltip',
    defaultMessage:
      'Reset the application to allow the applicant to start over from the eligibility screen',
  },
  feesPaidTooltip: {
    id: 'ResidentPortal.feesPaidTooltip',
    defaultMessage:
      'Cannot reset the application once charges have been applied or fees have been paid',
  },
  paymentSectionCompletedTooltip: {
    id: 'ResidentPortal.paymentSectionCompletedTooltip',
    defaultMessage:
      'Cannot reset the application after the payment section has been completed.',
  },
  feesAppliedTooltip: {
    id: 'ResidentPortal.feesAppliedTooltip',
    defaultMessage: 'Cannot reset the application once fees have been applied.',
  },
  noPermissionTooltip: {
    id: 'ResidentPortal.noPermissionTooltip',
    defaultMessage: 'You do not have permission to perform this action.',
  },
  queryErrorTooltip: {
    id: 'ResidentPortal.queryErrorTooltip',
    defaultMessage:
      'Cannot reset the application. Unable to load fee information, please try again.',
  },
  resetButtonText: {
    id: 'ResidentPortal.resetButtonText',
    defaultMessage: 'Reset Application',
  },
  nonPrimaryInviteDisabledTooltip: {
    id: 'ResidentPortal.nonPrimaryInviteDisabledTooltip',
    defaultMessage:
      'The Head of Household must claim their portal account, create, & confirm their household ' +
      'in portal before other household members can be invited.',
  },
  noEmailInviteDisabledTooltip: {
    id: 'ResidentPortal.noEmailInviteDisabledTooltip',
    defaultMessage:
      '{customerStatusTitle} must have an email address to receive a {panelTitle} invite',
  },
});
